import { applyKeyframe } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css, keyframes } from 'styled-components';

import { slideBottomCorner } from 'src/components/molecules/HeroCarouselItem/HeroCarouselItem.styles';
import { slideInset } from './HeroCarousel.styles';

const { colors } = themeVariables;

const HEIGHT = '4px';
const FADE_MS = 150;

/*
 * Scale rather than width so the animation stays on the compositor: animating width would lay out
 * and paint every frame for the whole duration of every slide.
 */
const fill = keyframes`
  from {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
`;

/* Sits on the bottom edge of the current image, spanning the active slide. */
export const track = css`
  position: absolute;
  bottom: 0;
  ${slideInset};
  height: ${HEIGHT};
  z-index: 1;
  overflow: hidden;
  /* Follows the image's rounded bottom edge, which does not clip this because it is a sibling. */
  ${slideBottomCorner};
  /* Let clicks through to the image link beneath, as the heading does. */
  pointer-events: none;
  /* content.action is the colour the heading uses over this same imagery, so it reads on both. */
  background-color: color-mix(in srgb, var(${colors.content.action}) 40%, transparent);
  transition: opacity ${FADE_MS}ms ease;

  /*
   * Hidden while the carousel slides, so the bar is not seen resetting to empty mid-move. Opacity
   * rather than display, because the fill inside is the autoplay timer and a display: none subtree
   * suspends CSS animations, which would stop autoplay (see AutoplayProgressBar).
   */
  &[data-transitioning='true'] {
    opacity: 0;
  }
`;

export const progress = css`
  position: absolute;
  inset: 0;
  background-color: var(${colors.content.action});
  transform-origin: left center;
  animation-name: ${applyKeyframe(fill)};
  animation-timing-function: linear;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;
